import { useContext, useEffect, useState } from 'react';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import RateReviewIcon from '@mui/icons-material/RateReview';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import AddBoxIcon from '@mui/icons-material/AddBox';
import PlaceIcon from '@mui/icons-material/Place';
import MapIcon from '@mui/icons-material/Map';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import PeopleIcon from '@mui/icons-material/People';
import AuthContext from '../../context/auth/authContext';

const drawerWidth = 240;

const LeftNav = ({ mobileOpen, onMobileClose }) => {
    const [createOpen, setCreateOpen] = useState(false);
    const authContext = useContext(AuthContext);
    useEffect(() => {
        authContext.loadUser();
        // eslint-disable-next-line
    }, []);
    const {
        isAuthenticated,
    } = authContext;

    const drawerContent = (
        <>
            <Toolbar />
            <Box sx={{ overflow: 'auto' }}>
                <List>
                    <ListItem key="destination" disablePadding>
                        <ListItemButton to="/destinations" onClick={onMobileClose}>
                            <ListItemIcon>
                                <MapIcon />
                            </ListItemIcon>
                            <ListItemText primary={"Discover"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key="spot" disablePadding>
                        <ListItemButton to="/spots" onClick={onMobileClose}>
                            <ListItemIcon>
                                <PlaceIcon />
                            </ListItemIcon>
                            <ListItemText primary={"Local Finds"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem key="create" disablePadding>
                        <ListItemButton onClick={() => setCreateOpen(!createOpen)}>
                            <ListItemIcon>
                                <AddBoxIcon />
                            </ListItemIcon>
                            <ListItemText primary={"Create New"} />
                            {createOpen ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={createOpen} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItemButton sx={{ pl: 4 }} href="/create/trip" onClick={onMobileClose}>
                                <ListItemIcon>
                                    <FlightTakeoffIcon />
                                </ListItemIcon>
                                <ListItemText primary={"Create Trip"} />
                            </ListItemButton>
                            <ListItemButton sx={{ pl: 4 }} href="/create/review" onClick={onMobileClose}>
                                <ListItemIcon>
                                    <RateReviewIcon />
                                </ListItemIcon>
                                <ListItemText primary={"Create Review"} />
                            </ListItemButton>
                        </List>
                    </Collapse>
                </List>
                {isAuthenticated && (
                    <>
                        <Divider />
                        <List>
                            <ListItem key="following" disablePadding>
                                <ListItemButton to="/following" onClick={onMobileClose}>
                                    <ListItemIcon>
                                        <PeopleIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={"Following"} />
                                </ListItemButton>
                            </ListItem>
                            <ListItem key="my-journeys" disablePadding>
                                <ListItemButton to="/my-journeys" onClick={onMobileClose}>
                                    <ListItemIcon>
                                        <BookmarksIcon />
                                    </ListItemIcon>
                                    <ListItemText primary={"My Journeys"} />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </>
                )}
            </Box>
        </>
    );

    return (
        <>
            {/* Mobile: temporary drawer that overlays */}
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={onMobileClose}
                ModalProps={{ keepMounted: true }}
                sx={{
                    display: { xs: 'block', md: 'none' },
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                }}
            >
                {drawerContent}
            </Drawer>

            {/* Desktop: permanent drawer */}
            <Drawer
                variant="permanent"
                sx={{
                    display: { xs: 'none', md: 'block' },
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                }}
            >
                {drawerContent}
            </Drawer>
        </>
    );
}
export default LeftNav;
